import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Loader from "../../../components/DefaultStyles/Loader";
import { Textarea } from "../../../components/Input/Textarea";
import AlertModal from "../../../components/Modal/AlertModal";
import DefaultModalLayout from "../../../components/Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../../components/pages/Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../../components/pages/Users/UserDetail/CommentModal/CommentModal";
import { useApi } from "../../../hooks/useApi";

interface ReJoinModalProps extends DefaultModalCommonProps {
  user: string;
}

export default function ReJoinModal({
  closeEvent,
  confirmEvent,
  user,
}: ReJoinModalProps) {
  const [reason, setReason] = useState("");
  const [btnClick, setBtnClick] = useState(false);
  const [askModal, setAskModal] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: btnClick ? `user/exit` : undefined,
    data: {
      uid: +user?.split("_")[0],
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      if (closeEvent) {
        closeEvent();
      }

      if (confirmEvent) {
        confirmEvent();
      }
      toast.success("재가입이 허용되었습니다.", {});
    }
  }, [closeEvent, response]);

  useEffect(() => {
    if (error) {
      setBtnClick(false);
      toast.error(error?.data ?? "재가입 허용에 실패했습니다.");
    }
  }, [error]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => setAskModal(true)}
      modalTitle="탈퇴 회원 재가입"
      type="input"
      isSmallModal={true}
      confirmDisabled={reason === ""}
      modalDesc="30일 이내 탈퇴한 회원의 재가입이 허용됩니다."
    >
      <DeleteModalLabel>재가입 사유</DeleteModalLabel>

      <Textarea
        placeholder="재가입 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />

      <>
        {loading && <Loader />}

        {askModal && (
          <AlertModal
            title={`${user}님의\n링키드 재가입이 허용됩니다.\n계속하시겠습니까?`}
            confirmEvent={() => {
              setBtnClick(true);
              setAskModal(false);
            }}
            cancelEvent={() => setAskModal(false)}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}
